export const convertFileToDataUri = file => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            if (typeof reader.result !== "string") {
                reject(new Error("Failed to convert file to a Data URI."));
                return;
            }

            const base64Separator = ";base64,";
            const separatorIndex = reader.result.indexOf(base64Separator);

            if (separatorIndex === -1) {
                reject(new Error("Failed to convert file to a Data URI."));
                return;
            }

            const encodedFileName = encodeURIComponent(file.name).replace(/[()']/g, character =>
                `%${character.charCodeAt(0).toString(16).toUpperCase()}`
            );

            // Preserve the original filename as a media type parameter for the upload and prompt backends.
            resolve(
                `${reader.result.slice(0, separatorIndex)};name=${encodedFileName}${reader.result.slice(separatorIndex)}`
            );
        };
        reader.onerror = error => reject(error);
        reader.readAsDataURL(file);
    });
};
